<script>
import QueryExpandWrapper from '@/components/Crud/QueryExpandWrapper/index.vue'
import { page } from '@/api/business/crmCustomer'

export default {
  name: 'FundCostItemSelectDialog',
  components: { QueryExpandWrapper },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    defaultActivePane: {
      type: String,
      default: 'customer'
    },
    title: {
      type: String,
      default: '选择公司'
    }
  },
  data() {
    return {
      show: false,
      list: [],
      selectedRecords: [],
      selectedRow: null,
      loading: false,
      queryParams: {
        customerName: null,
        page: 1,
        size: 10,
        sort: ['create_time,desc']
      },
      total: 0,
      isQueryShow: true,

      activePane: null
    };
  },
  computed: {
    multipleDisabled() {
      if (this.multiple) {
        return this.selectedRecords.length === 0;
      }
      return false;
    }
  },
  methods: {
    open() {
      this.activePane = this.defaultActivePane
      this.show = true
      this.onTabSwitch()
    },
    async onQuery() {
      this.loading = true
      try {
        const res = await page(this.queryParams)
        this.list = res.data.records
        this.total = res.data.total
      } catch (error) {
        console.error('加载数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    onSubmit() {
      if (this.multiple) {
        this.$emit('complete', this.selectedRecords);
      } else {
        this.$emit('complete', this.selectedRow);
      }
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    onSelectionChange({ records }) {
      this.selectedRecords = records;
    },
    onRadioChange({ row }) {
      this.selectedRow = row
    },
    onRefresh() {
      this.queryParams = this.$options.data().queryParams
      this.onTabSwitch()
    },
    onTabSwitch() {
      switch (this.activePane) {
        case 'customer':
          this.queryParams.customerType = this.$enums.CUSTOMER_TYPE.CUSTOMER.value
          break
        case 'supplier':
          this.queryParams.customerType = this.$enums.CUSTOMER_TYPE.SUPPLIER.value
          break
        case 'ourCompany':
          this.queryParams.customerType = this.$enums.CUSTOMER_TYPE.OUR_COMPANY.value
          break;
        default:
          this.queryParams.customerType = null
          break
      }
      this.onQuery()
    }
  }
}
</script>

<template>
  <el-dialog
    :title="title"
    :visible="show"
    width="700px"
    append-to-body
    @update:visible="show = $event"
  >
    <query-expand-wrapper :show="isQueryShow">
      <el-form :model="queryParams" :inline="true">
        <el-form-item label="全称" prop="customerName">
          <el-input
            v-model="queryParams.customerName"
            :placeholder="$t('general.placeholder.enter.search')"
            clearable
            style="width: 100%;"
            @change="onQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onQuery">{{ $t('general.query.search') }}</el-button>
          <el-button icon="el-icon-refresh" plain @click="onRefresh">{{ $t('general.query.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </query-expand-wrapper>
    <el-tabs v-model="activePane" type="card" @tab-click="onTabSwitch" class="eu-tabs">
      <el-tab-pane label="客户" name="customer"></el-tab-pane>
      <el-tab-pane label="供应商" name="supplier"></el-tab-pane>
      <el-tab-pane label="本方公司" name="ourCompany"></el-tab-pane>
    </el-tabs>
    <vxe-table
      id="table"
      border
      resizable
      show-overflow
      ref="table"
      :loading="loading"
      :data="list"
      :row-config="{isHover: true}"
      @checkbox-all="onSelectionChange"
      @checkbox-change="onSelectionChange"
      @radio-change="onRadioChange"
    >
      <template v-if="multiple">
        <vxe-column type="checkbox" width="40" fixed="left"></vxe-column>
      </template>
      <template v-else>
        <vxe-column type="radio" width="40" fixed="left"></vxe-column>
      </template>
      <vxe-column
        field="customerName"
        title="全称"
        :visible="true"
        min-width="100"
      >
      </vxe-column>
      <vxe-column
        field="customerShortName"
        title="简称"
        :visible="true"
        min-width="100"
      >
      </vxe-column>
    </vxe-table>
    <pagination
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.size"
      @pagination="onQuery"
    />
    <template #footer>
      <div class="flex align-center justify-between">
        <div v-if="multiple">
          <span>共选中</span>
          <span class="text-primary">{{ selectedRecords.length }}</span>
          <span>条</span>
        </div>
        <div v-else></div>
        <div>
          <el-button @click="onCancel">取消</el-button>
          <el-button type="primary" @click="onSubmit" :disabled="multipleDisabled">确认</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.pagination-container {
  margin-top: 10px;
  text-align: right;
}
</style>